import inSection from "./in-section.util";

export const CALLS_DESTINATIONS = inSection("/calls", [
  {
    to: "overview",
    label: "Analytics",
    when: ({ roles }) => roles.isSunoAdminOrBusinessOwner
  },
  { to: "call-logs", label: "Call Logs" },
  { to: "voicemails", label: "Voicemails" },
  // ENG-2177: the practice's non-patient contacts; part of Voice, no gate of
  // its own beyond the section's.
  { to: "rolodex", label: "Rolodex", keywords: ["contacts"] }
]);
